import { render, staticRenderFns } from "./CustomerActionsDesktop.vue?vue&type=template&id=c75f74b2&"
import script from "./CustomerActionsDesktop.vue?vue&type=script&lang=js&"
export * from "./CustomerActionsDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports